// Thanks: https://mauricereigman.medium.com/immutable-typescript-classes-with-object-copywith-typesafe-a84fff3971dc
export class Clonable {
  public clone(data: Partial<typeof this>): this {
    return Object.assign(Object.create(this.constructor.prototype), { ...this, ...data });
  }
}
